<template>
    <router-link
        v-if="thumb.push"
        to="/fr/menu"
        :data-id="thumb.categoryId"
        class="c-thumb c-thumb--push"
    >
        <span class="c-thumb__content">
            <h3 class="c-thumb__title | t-t3">{{ thumb.title }}</h3>
            <Btn tag="span">
                <span class="u-dn@xs-max">Consulter </span>tous les plats
            </Btn>
        </span>
    </router-link>
    <a
        v-else
        :title="`${thumb.title}, cliquez pour commander`"
        :href="`/fr/commande-en-ligne/#/?service=takeout&showItem=${thumb.ueatId}`"
        class="c-thumb"
        :class="{ 'c-thumb--lunch' : thumb.lunchBox }"
    >
        <span class="c-thumb__inner">
            <span class="c-thumb__top">

                <span
                    v-if="thumb.regularPrice != thumb.displayPrice"
                    class="c-thumb__price c-thumb__price--discount"
                >
                        {{ thumb.regularPrice|price }}
                    <del>{{ thumb.displayPrice|price }}</del>
                </span>
                <span
                    v-else
                    class="c-thumb__price"
                >
                    {{ thumb.displayPrice|price }}
                </span>

                <Btn
                    v-if="thumb.lunchBox"
                    tag="span"
                    label="Minimum 10 personnes"
                    class="c-btn--rounded c-btn--light"
                />
                <Btn
                    v-else-if="thumb.regularPrice != thumb.displayPrice"
                    tag="span"
                    label="Promo"
                    class="c-btn--rounded c-btn--secondary"
                />
                <Btn
                    v-else-if="thumb.novelty"
                    tag="span"
                    label="Nouveauté"
                    class="c-btn--rounded"
                />
            </span>
            <span
                v-if="thumb.cover"
                class="c-thumb__asset"
            >
                <Asset
                    :webpSrcset="thumb.cover_webp_srcset"
                    :srcset="thumb.cover_srcset"
                    :src="thumb.cover|resources('images')"
                    :alt="thumb.title"
                    class="c-thumb__img"
                    @imageLoaded="$emit('imageLoaded')"
                ></Asset>
            </span>
            <span class="c-thumb__content">
                <h3 class="c-thumb__title | t-t3">{{ thumb.title }}</h3>
                <p
                    v-if="thumb.description"
                    class="c-thumb__desc | t-xs text-dark"
                >
                    {{ thumb.description }}
                </p>

            </span>

            <span
                v-if="!isEmpty(thumb.tags)"
                class="c-thumb__bottom"
            >

                <span
                    v-for="(tag, key) in formattedTags"
                    :key="key"
                    class="c-thumb__label"
                >
                    <Icon
                        :icon="key"
                        :fallback="(validTags.indexOf(key) === -1) ? 'true' : false"
                    ></Icon>
                    <span class="c-thumb__tooltip">
                        <span class="t-cms">
                            <h3 class="t-t3">{{ tag.name}}</h3>
                            <p v-if="tag.description">{{ tag.description }}</p>
                        </span>
                    </span>
                </span>

                <span
                    v-if="thumb.calories"
                    class="c-thumb__calories"
                >
                    {{ thumb.calories }} CAL
                </span>
            </span>
        </span>

        <Btn
            tag="span"
            class="c-btn--filled | c-thumb__order"
            :class="{ 'c-thumb__order--bottom' : isEmpty(thumb.tags) && !thumb.calories }"
        >
            Commander <span class="u-dn@xs-max">en ligne</span>
        </Btn>
    </a>
</template>

<script>/* eslint-disable */

    import { slugify } from 'utils/utils'

    import Asset from 'components/Asset'
    import Icon from 'components/Icon'
    import Btn from 'components/Btn'
    import isEmpty from 'lodash/isEmpty'

    export default {
        name: 'Thumb',
        components: {
            Asset,
            Icon,
            Btn
        },
        data: () => ({
            validTags: [
                'vegetarien',
                'sans-gluten',
            ],
            isEmpty: isEmpty,
        }),
        props: {
            thumbs: {
                type: Object,
                default: () => ({})
            }
        },
        computed: {
            thumb() {
                return Object.assign({
                    push: false,
                    lunchBox: false,
                    novelty: false,
                    title: 'Item',
                    description: 'Description',
                }, this.thumbs);
            },
            formattedTags() {
                let _newTags = {};

                for (const [key, value] of Object.entries(this.thumb.tags)) {
                    let _key = slugify(value.description)
                    _newTags[_key] = value
                }

                return _newTags
            }
        },
    }
</script>

<style scoped>
</style>
